<ng-template #rtCountry let-country="country" let-t="term" let-showClear="showClear">
  <div class="w-100 d-flex justify-content-left align-items-center">
    <span class="d-inline-block iti-flag" [ngClass]="getFlagClass(country.code)"></span>
    <ngb-highlight class="ms-2 text-left flex-fill" [result]="country.name" [term]="t"></ngb-highlight>
    @if(showClear) {
    <i class="icon icon-times text-danger" (click)="clearCountry()"></i>
    }
  </div>
</ng-template>

<div ngbDropdown #dropdown class="dropdown dropdown-icon-right" [display]="'dynamic'">
  <button
    class="bg-white border current-selection w-100 btn btn-simple btn-round dropdown-toggle m-0 d-flex align-items-center {{
      showError() ? 'border-danger' : 'border-light-gray'
    }}"
    ngbDropdownToggle
    [disabled]="readonly()"
  >
    @if (!currentCountry) {
    <div class="w-100 d-flex align-items-center">
      <i class="icon icon-globe me-2"></i>
      <span>{{ placeholder }}</span>
    </div>
    }@else {
    <ng-container
      [ngTemplateOutlet]="rtCountry"
      [ngTemplateOutletContext]="{ country: currentCountry, showClear: true }"
    >
    </ng-container>
    }
  </button>
  <div ngbDropdownMenu class="w-100 dropdown-limit">
    <div class="w-100 d-flex flex-column dropdown-limit">
      <div class="p-1 w-100">
        <input
          type="text"
          [formControl]="filterFormControl"
          [placeholder]="'Filter countries...' | translate"
          class="form-control d-inline-block mt-0"
        />
      </div>
      <div class="dropdown-divider mt-0"></div>
      <div class="overflow-scroll flex-fill" #scroller>
        @for(country of countries$ | async; track country.name ) {
        <a
          class="dropdown-item d-flex"
          id="country-{{ country.code }}"
          (click)="selectCountry(country)"
          [ngClass]="{ active: country.code === currentCountry?.code }"
        >
          <ng-container
            [ngTemplateOutlet]="rtCountry"
            [ngTemplateOutletContext]="{ country, term: filterFormControl.value  }"
          >
          </ng-container>
        </a>
        }
      </div>
    </div>
  </div>
</div>
